import { PRIORITY_LOW, PRIORITY_NORMAL, PRIORITY_HIGH } from './priorities';
import {
  CITY,
  BOOKING_ID,
  MOVE_IN_DATE,
  NAME,
  EMAIL,
  COMMENT,
  RENTABLE_UNIT_ID
} from './formFields';

export const MODIFY_PICTURES = 'modify_pictures';
export const LISTING_MODIFICATION = 'listing_modification';
export const UNPUBLISH_REQUEST = 'unpublish_request';
export const ACTIVATE_INSTANT_BOOKING = 'activate_instant_booking';
export const BOOKING_STATUS = 'booking_status';
export const TENANT_COMPLAINT = 'tenant_complaint';
export const LANDLORD_DATES_MODIFICATION = 'landlord_dates_modification';
export const LANDLORD_BC_CANCELLATION = 'landlord_bc_cancellation';
export const PAYMENT_MISSING = 'payment_missing';
export const CLAIM_GUARANTEE = 'claim_guarantee';
export const LL_PANEL_ACCESS = 'llpanel_access';
export const LL_PANEL_BUG = 'llpanel_bug';
export const LL_PANEL_DOUBTS = 'llpanel_doubts';
export const COMMERCIAL_ADVICE = 'commercial_advice';
export const LANDLORD_ACCOUNT_ACCESS = 'landlord_account_access';
export const LANDLORD_CHANGE_CONTACT_DETAILS =
  'landlord_change_contact_details';
export const LANDLORD_DELETE_ACCOUNT = 'landlord_delete_account';
export const PUBLISH_PROPERTIES = 'publish_properties';

export const LANDLORD_REASON_IDS = [
  MODIFY_PICTURES,
  LISTING_MODIFICATION,
  UNPUBLISH_REQUEST,
  ACTIVATE_INSTANT_BOOKING,
  BOOKING_STATUS,
  TENANT_COMPLAINT,
  LANDLORD_DATES_MODIFICATION,
  LANDLORD_BC_CANCELLATION,
  PAYMENT_MISSING,
  CLAIM_GUARANTEE,
  LL_PANEL_ACCESS,
  LL_PANEL_BUG,
  LL_PANEL_DOUBTS,
  COMMERCIAL_ADVICE,
  LANDLORD_ACCOUNT_ACCESS,
  LANDLORD_CHANGE_CONTACT_DETAILS,
  LANDLORD_DELETE_ACCOUNT,
  PUBLISH_PROPERTIES
];

const LL_BASIC_FIELDS = [NAME, EMAIL, CITY, COMMENT];
const LL_WITH_RUID_FIELDS = [NAME, EMAIL, CITY, RENTABLE_UNIT_ID, COMMENT];
const LL_WITH_MOVE_IN_AND_BOOKING_FIELDS = [
  NAME,
  EMAIL,
  CITY,
  BOOKING_ID,
  MOVE_IN_DATE,
  COMMENT
];

export const LANDLORD_REASONS = {
  modify_pictures: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I want to modify my pictures',
        suffix: 'city'
      },
      tags: ['new_pictures']
    },
    form: {
      fields: LL_WITH_RUID_FIELDS,
      helpCenterArticles: [
        'articles/360014618900-How-can-I-edit-the-photos-on-my-listing'
      ]
    }
  },
  listing_modification: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I want to modify my listing',
        suffix: 'city'
      },
      tags: ['listing_modification']
    },
    form: {
      fields: LL_WITH_RUID_FIELDS,
      helpCenterArticles: [
        'sections/360001611560-Manage-Your-Account-Landlord-Panel'
      ]
    }
  },
  unpublish_request: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I want to unpublish',
        suffix: 'city'
      },
      tags: ['unpublish_request']
    },
    form: {
      fields: LL_WITH_RUID_FIELDS,
      helpCenterArticles: []
    }
  },
  activate_instant_booking: {
    zendesk: {
      priority: PRIORITY_LOW,
      subject: {
        prefix: 'I want to activate the Instant Booking',
        suffix: 'city'
      },
      tags: ['instant_booking']
    },
    form: {
      fields: LL_WITH_RUID_FIELDS,
      helpCenterArticles: ['articles/360005350120-What-is-instant-booking']
    }
  },
  booking_status: {
    zendesk: {
      priority: PRIORITY_HIGH,
      subject: {
        prefix: 'I want information about a booking status',
        suffix: 'bookingId'
      },
      tags: ['booking_update']
    },
    form: {
      fields: LL_WITH_MOVE_IN_AND_BOOKING_FIELDS,
      helpCenterArticles: ['']
    }
  },
  tenant_complaint: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I want to raise a complaint about my tenant',
        suffix: 'bookingId'
      },
      tags: ['landlord_complaint']
    },
    form: {
      fields: LL_WITH_MOVE_IN_AND_BOOKING_FIELDS,
      helpCenterArticles: []
    }
  },
  landlord_dates_modification: {
    zendesk: {
      priority: PRIORITY_LOW,
      subject: {
        prefix: 'I want to modify a booking date',
        suffix: 'bookingId'
      },
      tags: ['dates_modification']
    },
    form: {
      fields: LL_WITH_MOVE_IN_AND_BOOKING_FIELDS,
      helpCenterArticles: ['articles/360004981699-How-can-I-manage-a-booking']
    }
  },
  landlord_bc_cancellation: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I want to cancel a booking',
        suffix: 'bookingId'
      },
      tags: ['bc_cancellation']
    },
    form: {
      fields: LL_WITH_MOVE_IN_AND_BOOKING_FIELDS,
      helpCenterArticles: ['articles/360005538739-How-do-I-cancel-a-booking']
    }
  },
  payment_missing: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I am missing a payment',
        suffix: 'bookingId'
      },
      tags: ['finance_request']
    },
    form: {
      fields: LL_WITH_MOVE_IN_AND_BOOKING_FIELDS,
      helpCenterArticles: [
        'articles/360014619980-When-will-I-receive-the-first-payment-'
      ]
    }
  },
  claim_guarantee: {
    zendesk: {
      priority: PRIORITY_HIGH,
      subject: {
        prefix: 'I want to claim my guarantee',
        suffix: 'bookingId'
      },
      tags: ['guarantee']
    },
    form: {
      fields: LL_WITH_MOVE_IN_AND_BOOKING_FIELDS,
      helpCenterArticles: [
        'articles/360005551019-What-is-the-Spotahome-Landlord-Guarantee'
      ]
    }
  },
  llpanel_access: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I can not access my LL panel',
        suffix: 'city'
      },
      tags: ['llpanel_access']
    },
    form: {
      fields: LL_BASIC_FIELDS,
      helpCenterArticles: [
        'articles/360014673379-What-should-I-do-if-I-have-problems-with-my-Landlord-Panel'
      ]
    }
  },
  llpanel_bug: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'Report a Bug',
        suffix: 'landlord'
      },
      tags: ['llpanel_bug']
    },
    form: {
      fields: LL_BASIC_FIELDS,
      helpCenterArticles: [
        'articles/360014673379-What-should-I-do-if-I-have-problems-with-my-Landlord-Panel'
      ]
    }
  },
  llpanel_doubts: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'How does LL Panel work',
        suffix: 'city'
      },
      tags: ['llpanel_doubts']
    },
    form: {
      fields: LL_BASIC_FIELDS,
      helpCenterArticles: [
        'sections/360001611560-Manage-Your-Account-Landlord-Panel'
      ]
    }
  },
  commercial_advice: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I need commercial advice',
        suffix: 'city'
      },
      tags: ['commercial_advice']
    },
    form: {
      fields: LL_WITH_RUID_FIELDS,
      helpCenterArticles: [
        'articles/360004201720-How-long-will-it-take-to-rent-my-property-through-Spotahome'
      ]
    }
  },
  landlord_account_access: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I can not access my account',
        suffix: 'landlord'
      },
      tags: ['login_issues']
    },
    form: {
      fields: LL_BASIC_FIELDS,
      helpCenterArticles: ['articles/360014669279-How-do-I-create-an-account']
    }
  },
  landlord_change_contact_details: {
    zendesk: {
      priority: PRIORITY_LOW,
      subject: {
        prefix: 'I want to change my contact details',
        suffix: 'landlord'
      },
      tags: ['change_accountdetails']
    },
    form: {
      fields: LL_BASIC_FIELDS,
      helpCenterArticles: []
    }
  },
  landlord_delete_account: {
    zendesk: {
      priority: PRIORITY_HIGH,
      subject: {
        prefix: 'I want to delete my account',
        suffix: 'landlord'
      },
      tags: ['delete_account']
    },
    form: {
      fields: LL_BASIC_FIELDS,
      helpCenterArticles: [
        'articles/360005602660-How-does-Spotahome-use-my-personal-data'
      ]
    }
  },
  publish_properties: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I want to publish my properties',
        suffix: 'city'
      },
      tags: ['lead_landlord']
    },
    form: {
      fields: LL_BASIC_FIELDS,
      helpCenterArticles: [
        'sections/360001361559-Listing-Your-Property',
        'sections/360001334760-Getting-Started'
      ]
    }
  }
};
